import {
  GENERIC_ERROR_MESSAGE,
  GENERIC_ERROR_TITLE,
  INFO_TITLE,
  LOGIN_EMAIL_NOT_CONFIRMED,
  LOGIN_INVALID_CREDENTIALS_MESSAGE,
  LOGIN_SUCCESS_MESSAGE,
  LOGIN_SUCCESS_TITLE,
  SERVER_ERROR_MESSAGE,
  SERVER_ERROR_TITLE,
  CONFIRMATION_RESENT_TITLE,
  CONFIRMATION_RESENT_MESSAGE,
  RESEND_RATE_LIMITED_TITLE,
  RESEND_RATE_LIMITED_MESSAGE,
} from "@/constants/messages";

export const TOAST_MESSAGES = {
  GENERIC_ERROR: {
    title: GENERIC_ERROR_TITLE,
    description: GENERIC_ERROR_MESSAGE,
  },
  SUCCESS: {
    title: LOGIN_SUCCESS_TITLE,
    description: LOGIN_SUCCESS_MESSAGE,
  },
  SERVER_ERROR: {
    title: SERVER_ERROR_TITLE,
    description: SERVER_ERROR_MESSAGE,
  },
  INVALID_CREDENTIALS: {
    title: "",
    description: LOGIN_INVALID_CREDENTIALS_MESSAGE,
  },
  EMAIL_NOT_CONFIRMED: {
    title: INFO_TITLE,
    description: LOGIN_EMAIL_NOT_CONFIRMED,
  },
  CONFIRMATION_RESENT: {
    title: CONFIRMATION_RESENT_TITLE,
    description: CONFIRMATION_RESENT_MESSAGE,
  },
  OVER_EMAIL_SEND_RATE_LIMIT: {
    title: RESEND_RATE_LIMITED_TITLE,
    description: RESEND_RATE_LIMITED_MESSAGE,
  },
};
